import { render } from "./bigdataU.vue?vue&type=template&id=200ff2cb"
import script from "./bigdataU.vue?vue&type=script&lang=js"
export * from "./bigdataU.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__